import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { createFormatters, type Formatters } from './format';

/**
 * UI foundation 1.0c — the locale-aware formatters for the current i18n
 * language; re-created when the language switches. Every date/time call
 * still takes the zone explicitly: `f.time(iso, jobTimeZone(job))`.
 */
export function useFormatters(): Formatters {
  const { t, i18n } = useTranslation();
  // `i18n?.`: a bare `{ t }` (some component-test mocks) must not throw.
  const language = i18n?.resolvedLanguage ?? i18n?.language;
  return useMemo(() => createFormatters(t, language), [t, language]);
}
